import BaResource from '@/resources/BaResource';

export default class Ba {
    constructor() {
        this.Resource = new BaResource()
    }

    async connect (websiteId) {
        const ba = await this.Resource.connect(websiteId)
        return ba.data.bingAdsConnectionUrl
    }

    async set (code) {
        return await this.Resource.set(code)
    }
}